import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; 
import "./App.css";
import Hero from './images/illustration-hero.svg';

const Main = () => {
    return (
        <main>
            <div className='first-section'>
                <h1>A Simple Bookmark Manager</h1>
                <p> A clean and simple interface to organize your favourite websites. Open a new 
                browser tab and see your sites load instantly. Try it for free.</p>
                <button className='btn1'>
                    Get it on Chrome
                </button>
                <button className='btn2'>
                    Get it on Firefox
                </button>
            </div>
            <div className="second-section">
                <img src={Hero} />
            </div>
        </main>
    );
}

export default Main;
